<section>
  <div class="content-2">
    <div class="title-container">
      <h1 class="title">Funcionários: quadro e remuneração</h1>
      <h2 class="subtitle">
        Informe a composição do quadro de funcionário das escolas.
      </h2>
    </div>

    <hr class="division-line" />

    <div class="dropdown-panel panel">
      <app-menu-suspenso
        #menuTooltip="matTooltip"
        [matTooltip]="menuTooltipVisible ? 'Visualizar o PQR' : ''"
        matTooltipPosition="above"
        [opcoes]="[
          {
            rotulo: 'PQR desta funcionalidade',
            icone: 'computer',
            acao: 'pqrDestaFuncionalidade'
          },
          {
            rotulo: 'Restaurar valores com base no PQR',
            icone: 'content_copy',
            acao: 'restaurarValoresComBaseNoPqr'
          },
          {
            rotulo: 'PQR completo em nova aba',
            icone: 'desktop_windows',
            acao: 'pqrCompletoEmNovaAba'
          }
        ]"
        (chamadaDeAcao)="chamarAcao($event)"
      >
        Padrão de qualidade de referência (PQR)
      </app-menu-suspenso>

      <mat-icon
        (mouseenter)="openTooltips()"
        (mouseleave)="closeTooltips()"
        class="info-icon"
        #infoTooltip="matTooltip"
        matTooltip="Informações sobre o PQR"
        matTooltipPosition="left"
      >
        info
      </mat-icon>
    </div>
    <div class="panel">
      <div class="table-wrapper">
        <div class="table-scroll" role="region">
          <app-tabela
            ngSkipHydration
            class="table-component"
            [cabecalhoCustomizado]="true"
          >
            <ng-container cabecalho>
              <tr>
                <th class="table-header" rowspan="2" style="width: 2%">
                  <button
                    mat-icon-button
                    class="botao-adicionar diminui-botao"
                    (click)="adicionarLinha()"
                  >
                    <mat-icon>add</mat-icon>
                  </button>
                </th>
                <th class="table-header" colspan="2" style="width: 25%">
                  Função
                </th>
                <th class="table-header" colspan="2" style="width: 5%">
                  Localização
                </th>
                <th class="table-header" rowspan="2" style="width: 10%">
                  Mínimo de matrícula / Função
                </th>
                <th class="table-header" colspan="2" style="width: 3540%">
                  Critérios para alocação (PQR)
                </th>
                <th class="table-header" rowspan="2" style="width: 15%">
                  Nível de formação
                </th>
                <th class="table-header" rowspan="2" style="width: 15%">
                  Remuneração média mensal para uma jornada semanal de 40h (R$)
                </th>
              </tr>
              <tr>
                <th class="table-header" style="width: 3%">Cód. Função</th>
                <th class="table-header" style="width: 20%">Área de atuação</th>
                <th class="table-header" style="width: 4%">Urbana</th>
                <th class="table-header" style="width: 4%">Rural</th>
                <th class="table-header" style="width: 10%">
                  Quantidade de matrícula / Profissional
                </th>
                <th class="table-header" style="width: 10%">Máximo / Escola</th>
              </tr>
            </ng-container>
            <ng-container corpo>
              <ng-container
                *ngFor="let dados of pqrQuadroFuncionariosRemuneracaoValores"
              >
                <tr>
                  <td class="table-cell">
                    <button
                      mat-icon-button
                      class="botao-excluir diminui-botao"
                      (click)="excluirLinha(dados)"
                    >
                      <mat-icon>close</mat-icon>
                    </button>
                  </td>
                  <td class="table-cell">{{ dados.codPqrQuadroFuncionariosRemuneracao }}</td>
                  <td class="table-cell">
                    <input
                      type="text"
                      class="display-input align-left"
                      [(ngModel)]="dados.tipoFuncao.areaAtuacao"
                      (ngModelChange)="atualizarValores()"
                    />
                  </td>
                  <td class="table-cell">
                    <mat-checkbox
                      [checked]="isLocalizacaoSelecionada(dados, 1)"
                      (change)="toggleLocalizacao(dados, 1, 'Urbana')"
                      color="primary"
                    />
                  </td>
                  <td class="table-cell">
                    <mat-checkbox
                      [checked]="isLocalizacaoSelecionada(dados, 2)"
                      (change)="toggleLocalizacao(dados, 2, 'Rural')"
                      color="primary"
                    />
                  </td>
                  <td class="table-cell">
                    <input
                      type="text"
                      class="display-input text-green"
                      [(ngModel)]="dados.qntMinMatriculaFuncao"
                      (ngModelChange)="atualizarValores()"
                    />
                  </td>
                  <td class="table-cell">
                    <input
                      type="text"
                      class="display-input text-green"
                      [(ngModel)]="dados.qntMatriculaProfissional"
                      (ngModelChange)="atualizarValores()"
                    />
                  </td>
                  <td class="table-cell">
                    <input
                      type="text"
                      class="display-input text-green"
                      [(ngModel)]="dados.qntMaxEscola"
                      (ngModelChange)="atualizarValores()"
                    />
                  </td>
                  <td class="table-cell">
                    <select
                      class="align-left display-input"
                      [(ngModel)]="dados.tipoNivelFormacao.descricao"
                      (ngModelChange)="atualizarValores()"
                    >
                      <option
                        *ngFor="let formacao of mapearFormacoes()"
                        [value]="formacao"
                      >
                        {{ formacao }}
                      </option>
                    </select>
                  </td>
                  <td class="table-cell">
                    <input
                      type="text"
                      appPtBrNumber
                      class="display-input text-green align-right"
                      [(ngModel)]="dados.remuneracaoBrutaMensal"
                      (ngModelChange)="atualizarValores()"
                    />
                  </td>
                </tr>
              </ng-container>
            </ng-container>
          </app-tabela>
        </div>
      </div>
    </div>
  </div>
</section>
